import { getGsap, type GSAP, type ScrollTrigger,  type Timeline, type Tween } from '@/js/gsap';
import { bus } from '@/js/bus';
import select from 'dom-select';
import { cl, isDesktop, Observer } from '@/js/utils';

let gsap: GSAP;
let scrollTrigger: ScrollTrigger;
let animations: Timeline | Tween[] = [];

function sectionReveal(parent: HTMLElement) {
  const trigger = select.all('.section-reveal', parent);
  trigger.forEach((trigger) => {
    const notOnce = trigger.hasAttribute('data-always');
    const fromBottom = trigger.getAttribute('data-reveal-bottom') === '';
    const rootMargin = fromBottom
      ? '0% 0% 10% 0%'
      : isDesktop(1024)
        ? '0% 0% -50% 0%'
        : '0% 0% -10% 0%';
    const { bottom } = trigger.getBoundingClientRect();
    if (bottom < window.innerHeight) {
      cl(trigger).add('section-revealed');
    }

    const observer = new Observer({
      rootMargin,
      class: 'section-revealed',
      once: !notOnce
    });

    observer.add(trigger);
  });
}

function setScrollAnimations(parent: HTMLElement) {
  select.all('.statements-scroll', parent).forEach((el) => {
    const slowEl = select('.statements-scroll-slow', el);
    const sectionHeight = el.getBoundingClientRect().height;
    const slowElHeight = slowEl.getBoundingClientRect().height;
    animations.push(
      gsap.to(slowEl, {
        y: `${sectionHeight - slowElHeight}px`,
        scrollTrigger: {
          trigger: el,
          scrub: true,
          start: 'top bottom',
          end: 'bottom top',
        }
      })
    )

    scrollTrigger.refresh();
    setTimeout(() => {
      scrollTrigger.refresh();
    }, 100)
  })

  const speedMap = [
    1.2,
    0.8,
    -1,
    0.8,
    2,
    1.5,
  ]
  select.all('.history-scroll', parent).forEach((el) => {
    select.all('.history-scroll-el', el).forEach((slowEl, i) => {
      const slowElHeight = slowEl.getBoundingClientRect().height;
      animations.push(
        gsap.to(slowEl, {
          y: `${speedMap[i] *( slowElHeight / 2)}px`,
          scrollTrigger: {
            trigger: el,
            scrub: true,
            start: 'top bottom',
            end: 'bottom top',
          }
        })
      )
    });

    scrollTrigger.refresh();
    setTimeout(() => {
      scrollTrigger.refresh();
    }, 100)
  })
}


function init(parent: HTMLElement | Document = document) {
  sectionReveal(parent as HTMLElement);
  setScrollAnimations(parent as HTMLElement);
}

function cleanup() {
  animations.forEach((animation: any) => {
    animation.kill();
  });
  animations = [];
}

bus.on('barba_enter', ({ next }) => {
  cleanup();
  requestAnimationFrame(() => {
    init(next.container);
  });
});

export default () => {
  getGsap((g, st) => {
    gsap = g;
    scrollTrigger = st;
    init();
  });
};
